import { z } from 'zod';
import { BaseSchema } from '../base/base.entity.model';
import * as FlatModels from '../../internal';

export const AnnotationTargetSchema = BaseSchema.extend({
  position: FlatModels.PointSharedModels.PointSchema,
  endType: FlatModels.AnnotationEntityModels.TipType.default(FlatModels.AnnotationEntityModels.TipType.enum.dot),
  endRadius: z.number().nullable().default(null),
  color: z.string().max(255).nullable().default(null),
  annotation: z.string().uuid().optional()
});

export type AnnotationTarget = z.infer<typeof AnnotationTargetSchema>;

export const AnnotationTargetEntityQueryResultSchema = FlatModels.EntityControlModels.EntityQueryResultSchema.extend({
  entity: AnnotationTargetSchema,
});

export type AnnotationTargetEntityQueryResult = z.infer<typeof AnnotationTargetEntityQueryResultSchema>;
